import { RadioRowDataProps } from '@modules/entertainment/models/radio.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import { LiveTvActionParams } from '@modules/entertainment/pages/live-tv/store/live-tv.model.ts';

export interface RadioActionParams {
  data?: RadioRowDataProps;
  id?: any;
  state?: any;
  handleClose?: () => void;
}
export interface RadioState extends CallStateMethods {
  callState: CallStateEnum;
  genreCallState: CallStateEnum;
  genreList: any[];
  createRow: (params: RadioActionParams) => void;
  editRow: (params: RadioActionParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose: () => void;
  }) => void;
  createGenre: (params: { data: any; handleClose?: () => void }) => void;
  editGenre: (params: { data: any; id: any; handleClose?: () => void }) => void;
  deleteGenre: (params: LiveTvActionParams) => void;
  getGenreList: () => void;
  isGenreLoading: () => boolean;
  isGenreLoaded: () => boolean;
  isGenreError: () => boolean;
}
interface RadioStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
  createGenre: 'createGenre';
  editGenre: 'editGenre';
  deleteGenre: 'deleteGenre';
  getGenreList: 'getGenreList';
  isGenreLoading: 'isGenreLoading';
  isGenreLoaded: 'isGenreLoaded';
  isGenreError: 'isGenreError';
}

export const RADIO_INITIAL_STATE: Omit<RadioStateMethods, keyof RadioState> = {
  genreList: [],
  callState: CallStateEnum.Init,
  genreCallState: CallStateEnum.Init
};
